export const HINT = (intl, agencyName) => intl.formatMessage({ id: "video-intro-hint" }).replace("{}", agencyName);
